import React, { useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  useMediaQuery,
  createTheme,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { getProgramDetails } from "../../service/myloyalty_services";
import { ReactComponent as SearchIcon } from "../../assets/images/svg/lockTag.svg";

export function SpendablePointsProgramGrid(props) {
  const blockConfig = props.page.components.find(
    (component) => component.block_type === "SpendablePointsGridBlock"
  );
  const blockStyles = blockConfig?.blockstyle_set[0];

  const siteConfig = useSelector((state) => state.config.retailerConfig);

  const theme = createTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const [loyaltyProgram, setLoyaltyProgram] = useState();
  const [error, setError] = useState(null);

  const useStyles = makeStyles((theme) => ({
    rootCtn: {
      maxWidth: "1200px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 auto",
    },
    titleSec: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      "& .pageTitle": {
        fontSize: "60px",
        fontFamily: "switzer",
        fontWeight: "600",
        margin: "12px 0",
        color: blockStyles ? blockStyles.text_color : "#000",
        letterSpacing: "1px",
      },

      "& .ptsLabel": {
        fontSize: "28px",
        fontWeight: "700",
        color: blockStyles ? blockStyles.text_color : "#000",
        lineHeight: "30.8px",
      },

      // Ipad
      [theme.breakpoints.down("md")]: {
        padding: "0 12px",

        "& .pageTitle": {
          fontSize: "32px",
        },

        "& .ptsLabel": {
          fontSize: "24px",
        },
      },

      // Mobile
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "20px 10px",

        "& .pageTitle": {
          margin: "0",
          fontSize: "30px",
        },

        "& .ptsLabel": {
          fontSize: "16px",
        },
      },
    },
    rewardsGrid: {
      display: "grid",
      // gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
      gridTemplateColumns: "repeat(3, minmax(340px, 1fr))",

      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "repeat(2, 1fr)",
      },
    },
    rewardItem: {
      borderRight: "1px solid #CCD1D7",
      borderBottom: "1px solid #CCD1D7",
      display: "flex",
      justifyContent: "center",
      padding: "24px",

      "& .rewardImg": {
        width: "350px",
        height: "auto",

        [theme.breakpoints.down("md")]: {
          width: "180px",
          height: "180px",
        },

        [theme.breakpoints.down("xs")]: {
          width: "140px",
          height: "140px",
        },
      },

      "& .lockIcon": {
        position: "absolute",
        right: "-8px",
        bottom: "-30px",

        [theme.breakpoints.down("md")]: {
          "& svg": {
            width: "80px",
          },
        },

        [theme.breakpoints.down("xs")]: {
          right: "-2px",
          bottom: "-48px",

          "& svg": {
            width: "54px",
          },
        },
      },

      "& .rewardInfoSection": {
        width: "100%",

        "& .title": {
          marginTop: "1rem",
          marginBottom: "0",
          fontWeight: "700",
          lineHeight: "19.8px",
          fontFamily: "switzer",
          fontSize: "18px",
          color: blockStyles ? blockStyles.text_color : "#000",

          [theme.breakpoints.down("xs")]: {
            fontSize: "16px",
          },
        },

        "& .desc": {
          fontWeight: "400",
          color: blockStyles ? blockStyles.text_color : "#000",
          lineHeight: "24px",
          fontFamily: "switzer",
          fontSize: "16px",
          marginTop: "4px",

          [theme.breakpoints.down("xs")]: {
            fontSize: "14px",
          },
        },
      },
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    getLoyaltyProgramDetails();
  }, []);

  const getLoyaltyProgramDetails = async () => {
    const response = await getProgramDetails(
      siteConfig.dpn_instance.dpn_instance,
      siteConfig.dpn_instance.loyalty_program_id,
      localStorage.getItem("token")
    );
    if (!response.error) {
      if (response) {
        setLoyaltyProgram(response);
      }
    } else {
      setError("Error");
    }
  };

  const showRewardLock = (program) => {
    return (
      loyaltyProgram?.lifetimePoints >= program.targetThreshold &&
      new Date(program.offer.expirationDate) >= new Date()
    );
  };

  const getProducts = (rewardGroups) => {
    let products = [];
    let tagsMap = new Map();

    for (let rg of rewardGroups) {
      for (let reward of rg.rewards) {
        // Push the each uniq tag offer
        if (
          reward.offer.tags.length != 0 &&
          !tagsMap.get(reward.offer.tags[0])
        ) {
          reward.targetThreshold = rg.targetThreshold;
          products.push(reward);
          tagsMap.set(reward.offer.tags[0], reward.offer.value);
        }

        // Push the empty tag offers
        if (reward.offer.tags.length === 0) {
          reward.targetThreshold = rg.targetThreshold;
          products.push(reward);
        }
      }
    }

    return products;
  };

  return (
    <div className={classes.rootCtn}>
      <div className={classes.titleSec} item md={12} xs={12}>
        <div className="pageTitle">{blockConfig?.title}</div>
        {loyaltyProgram && (
          <div className="ptsLabel">
            Point balance:
            <span style={{ fontWeight: isMobile ? "600" : "400" }}>
              &nbsp;{loyaltyProgram?.lifetimePoints} Points
            </span>
          </div>
        )}
      </div>

      <div className={classes.rewardsGrid}>
        {loyaltyProgram?.rewardGroups?.length > 0 &&
          getProducts(loyaltyProgram.rewardGroups).map((program, idx) => (
            <Grid
              container
              direction="row"
              item
              justifyContent="flex-start"
              alignItems="stretch"
              className={classes.rewardItem}
              style={
                !isMobile
                  ? {
                      borderRight:
                        (idx + 1) % 3 === 0 ? "0" : "1px solid #CCD1D7",
                    }
                  : {}
              }
            >
              <div style={{ position: "relative" }}>
                <img
                  className="rewardImg"
                  src={
                    program.offer.enhancedImageUrl
                      ? program.offer.enhancedImageUrl
                      : program.offer.imageUrl
                  }
                />
                <div className="lockIcon">
                  {!showRewardLock(program) && (
                    <SearchIcon className="svgIcon" />
                  )}
                </div>
              </div>

              <div className="rewardInfoSection">
                <label className="title">
                  {program?.targetThreshold} Points
                </label>
                <p className="desc">{program.offer.description}</p>
              </div>
            </Grid>
          ))}
      </div>
    </div>
  );
}

export default SpendablePointsProgramGrid;
